import { QuestionTypeEnum } from "@propertelligent/client-api";

export type QuestionnaireQuestion = {
  questionText?: string | null;
  questionTypeId?: number | null;
  choices?: Array<{ optionText?: string | null }> | null;
  followUpQuestionChoiceId?: number | null;
  followUpQuestionText?: string | null;
};

export type QuestionnaireValidationResult =
  | { ok: true }
  | { ok: false; message: string };

const isBlank = (value?: string | null) => !value || !String(value).trim();

/**
 * Template authoring guard for Lease Application Questionnaires (sheet row 21).
 * Blocks Save when question/option/follow-up text is empty while a follow-up choice is configured.
 */
export function validateQuestionnaireQuestions(
  questions: QuestionnaireQuestion[] | null | undefined,
): QuestionnaireValidationResult {
  if (!questions || questions.length === 0) {
    return { ok: true };
  }

  for (const q of questions) {
    if (isBlank(q.questionText)) {
      return { ok: false, message: "Question text is required." };
    }

    const typeId = Number(q.questionTypeId);
    const isChoice =
      typeId === QuestionTypeEnum.SingleChoice ||
      typeId === QuestionTypeEnum.MultipleChoice;

    if (isChoice) {
      const choices = q.choices || [];
      for (const c of choices) {
        if (isBlank(c.optionText)) {
          return { ok: false, message: "Option text is required." };
        }
      }
    }

    const followUpChoiceId = Number(q.followUpQuestionChoiceId);
    if (
      typeId === QuestionTypeEnum.SingleChoice &&
      Number.isFinite(followUpChoiceId) &&
      followUpChoiceId > 0 &&
      isBlank(q.followUpQuestionText)
    ) {
      return {
        ok: false,
        message: "Follow-up question text is required.",
      };
    }
  }

  return { ok: true };
}
